export default window.Stripe(process.env.STRIPE_PUBLIC_KEY);
